import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';
import {CareproviderUnitService} from '../../../../services/careprovider-unit.service';
import {LoaderQueueItem} from '../../../../types/LoaderQueueItem';
import {finalize} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../../services/loader.service';
import {ToolsService} from '../../../../services/tools.service';
import {CareproviderUnitItem} from '../../../../types/CareproviderUnitItem';
import {SearchState} from '../../../../types/SearchState';
import {RoutesAddonsEnums, RoutesEnums} from '../../../../enums/RoutesEnums';
import {DefaultValuesService} from '../../../../services/default-values.service';
import {UrlBuilderService} from '../../../../services/url-builder.service';
import {AppConfigService} from '../../../../services/app-config.service';
import {ErrorReportService} from '../../../../services/error-report.service';

@Component({
  selector: 'app-booking-unavailable',
  templateUrl: './booking-unavailable.component.html',
  styleUrls: ['./booking-unavailable.component.scss'],
})
export class BookingUnavailableComponent implements OnInit, OnDestroy {
  public imgUrl: string;
  public shouldDisplayButtons: boolean = false;
  private careproviderUnit: CareproviderUnitItem;
  private subscriptions: Subscription[] = [];

  constructor(
    private bookingManager: BookingV2ManagerService,
    private careproviderUnitService: CareproviderUnitService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private tools: ToolsService,
    private router: Router,
    private defaults: DefaultValuesService,
    private urlBuilder: UrlBuilderService,
    private appConfigService: AppConfigService,
    private errorReportService: ErrorReportService,
  ) {
    this.imgUrl = `${appConfigService.appConfig.amazonS3Url}assets/illustrations/prosit-1.png`;
  }

  public ngOnInit(): void {
    this.getCpruData();
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public onErrorReportClick(): void {
    this.errorReportService.openErrorReportPage(true);
  }

  public onContactClick(): void {
    const routerLink: string[] = this.urlBuilder.CreateCareproviderUnitRouterLink(
      this.careproviderUnit.id,
      this.careproviderUnit.urlPath,
    );
    const url = this.urlBuilder.CreateStaticLink(routerLink);
    const targetUrl = `${url}#${RoutesAddonsEnums.CAREPROVIDER_CONTACT}`;
    window.location.assign(targetUrl);
  }

  public onSearchClick(): void {
    const state: SearchState = this.defaults.getDefaultSearchState(
      this.careproviderUnit?.mainCaregiverUnitType?.urlPath,
    );
    state.caregiverUnitTypeUrlPath = this.careproviderUnit?.mainCaregiverUnitType?.urlPath;
    state.placeUrlPath = this.careproviderUnit.placeUrlPath;
    const baseUrl: string[] = ['/', RoutesEnums.SEARCH];
    const routerLink: string[] = this.urlBuilder.CreateSearchResultsRouterLink(state, baseUrl);
    const queryParams = this.urlBuilder.CreateSearchResultsQueryParams(state);
    this.router.navigate(routerLink, {queryParams});
  }

  public onCloseClick(): void {
    this.bookingManager.closeBooking();
  }

  private getCpruData(): void {
    this.shouldDisplayButtons = false;
    const careproviderUnitId: number = parseInt(this.route.snapshot.params.providerId, 10);
    const queryId: number = this.loaderService.generateQueueId();
    const queryItem: LoaderQueueItem = {
      id: queryId,
      title: '',
      description: '',
    };
    this.loaderService.addToQueue(queryItem);
    this.subscriptions.push(
      this.careproviderUnitService
        .getCareproviderUnitById(careproviderUnitId)
        .pipe(
          finalize(() => {
            this.loaderService.removeFromQueue(queryId);
          }),
        )
        .subscribe(
          (result) => this.processCareproviderUnitResults(result),
          (error) => {
            console.error(error);
          },
        ),
    );
  }

  private processCareproviderUnitResults(careproviderUnitData: CareproviderUnitItem): void {
    this.careproviderUnit = careproviderUnitData;
    if (!this.tools.isNil(careproviderUnitData)) {
      this.shouldDisplayButtons = true;
    }
  }
}
